import { ERR_INVALID_ARGUMENT } from "../error";
/**
 * Returns true if the given object is an object.
 */
export function isObject(pObj) {
    if (pObj == null)
        return (false);
    return (typeof pObj === "object" || pObj instanceof Object);
}
/**
 * Returns true if the given object is plain object.
 */
export function isPlainObject(pObj) {
    if (!isObject(pObj))
        return (false);
    if (Object.prototype.toString.call(pObj) !== "[object Object]")
        return (false);
    var tProto = Object.getPrototypeOf(pObj);
    return (tProto === null || tProto === Object.prototype);
}
/**
 * Returns true if the object is null or does not contain own properties.
 */
export function isNullOrEmpty(pObject) {
    if (pObject == null)
        return (true);
    for (var tProp in pObject) {
        if (pObject.hasOwnProperty(tProp))
            return (false);
    }
    return (true);
}
/**
 * Creates a key/value map for the properties of the given object.
 */
export function toMap(pObject) {
    if (pObject == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    var tMap = new Map();
    for (var tProp in pObject) {
        tMap.set(tProp, pObject[tProp]);
    }
    return (tMap);
}
/**
 * Creates a plain object using the map entries as propeties.
 */
export function fromMap(pMap) {
    if (pMap == null)
        throw new Error(ERR_INVALID_ARGUMENT);
    var tObj = {};
    pMap.forEach(function (pValue, pKey) {
        tObj[pKey] = pValue;
    });
    return (tObj);
}
/**
 * Checks if two objects are shallow equal.
 */
export function shallowEqual(pObjectA, pObjectB) {
    if (pObjectA === pObjectB)
        return (true);
    if (pObjectA == null || pObjectB == null)
        return (false);
    var tKeysA = Object.keys(pObjectA);
    var tKeysB = Object.keys(pObjectB);
    if (tKeysA.length !== tKeysB.length) {
        return (false);
    }
    for (var _i = 0, tKeysA_1 = tKeysA; _i < tKeysA_1.length; _i++) {
        var tKey = tKeysA_1[_i];
        if (pObjectA[tKey] !== pObjectB[tKey]) {
            return (false);
        }
    }
    return (true);
}
